import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { container, sectionPad, btnPrimary } from "@/lib/ui";
import { IMAGES } from "@/data/business";
import { SERVICE_AREAS } from "@/data/suburbs";

export function ServiceAreasSection() {
  return (
    <section className={`${sectionPad} bg-navy relative overflow-hidden`} data-testid="service-areas-section">
      <div className="absolute inset-0 opacity-20">
        <img src={IMAGES.melbourneSkyline} alt="" aria-hidden="true" className="w-full h-full object-cover" loading="lazy" />
      </div>
      <div className="absolute inset-0 bg-navy/80" />
      <div className={`${container} relative`}>
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="text-xs tracking-[0.22em] uppercase font-semibold text-brandgreen-light">Service Areas</span>
            <h2 className="mt-3 font-heading text-3xl lg:text-4xl font-bold tracking-tight text-white">
              Proudly cleaning homes across Melbourne
            </h2>
            <p className="mt-4 text-white/75 leading-relaxed max-w-lg">
              JK House Cleaning provides reliable, detail-focused house cleaning across West Melbourne,
              East Melbourne and North Melbourne. Not sure if we can reach your home? Just ask when you
              request your quote.
            </p>

            <div className="mt-8 grid sm:grid-cols-3 gap-3">
              {SERVICE_AREAS.map((s) => (
                <div
                  key={s.name}
                  className="flex items-center gap-2 rounded-xl bg-white/5 border border-white/10 px-4 py-3"
                  data-testid={`area-tile-${s.name.toLowerCase().replace(/\s/g, "-")}`}
                >
                  <MapPin className="w-4 h-4 text-brandgreen-light shrink-0" />
                  <span className="text-sm font-medium text-white">{s.name}</span>
                </div>
              ))}
            </div>

            <Link to="/service-areas" className={`${btnPrimary} mt-8`} data-testid="areas-quote">
              View our service areas <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-white/10">
              <img
                src={IMAGES.melbourneStreet}
                alt="Leafy residential street in Melbourne"
                className="w-full h-[420px] object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
